import { StyleHeaderLogo, StyleHeaderRow, StyleHeaderWrapper } from './style'
import Container from '@components/container'
import Logo from './logo.png'
import Row from '@components/row'
import Button from '@components/button'
import { useNavigate } from 'react-router-dom'
import NavItems from './nav'
import PhoneMenu from '@pages/front/PhoneMenu'
const PublicHeader = () => {
  const navigate = useNavigate()
  return (
    <StyleHeaderWrapper>
      <Container>
        <StyleHeaderRow>
          <StyleHeaderLogo
            src={Logo}
            onClick={() => {
              navigate('/')
            }}
          />
          <PhoneMenu />
          <NavItems />
          <Row colGap={15} hidden>
            <Button
              outline={true}
              title="Register"
              styleButton="padding:0px 10px;"
              height={40}
              tc={'primary'}
              onClick={() => {
                navigate('/register-as-provider', {
                  state: {
                    purpose: 'Register',
                  },
                })
              }}
            />
            <Button
              title="Login"
              styleButton="padding:0px 10px;"
              height={40}
              onClick={() => {
                navigate('/login')
              }}
            />
          </Row>
        </StyleHeaderRow>
      </Container>
    </StyleHeaderWrapper>
  )
}

export default PublicHeader
